<h4 class="tds-u-pl1" *ngIf="batchJobStatusList.length > 0">Import Batch Job Status</h4>

<div *ngIf="batchJobStatusList.length <= 0">
    No batch job status to show
</div>

<tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width *ngIf="batchJobStatusList.length > 0">
    <tds-table-header>
        <tds-header-cell cell-key="jobType" cell-value="Batch job type"></tds-header-cell>
        <tds-header-cell cell-key="date" cell-value="Date"></tds-header-cell>
        <tds-header-cell cell-key="status" cell-value="Status" text-align="right"></tds-header-cell>
    </tds-table-header>
    <tds-table-body>
        <tds-table-body-row *ngFor="let batchJob of batchJobStatusList">
            <tds-body-cell
                cell-key="jobType"
                disable-padding="false">
                    {{ batchJob.batchJobType }}
            </tds-body-cell>
            <tds-body-cell
               cell-key="date"
               disable-padding="false">
                   {{ batchJob.date.toString().substring(0, 10) }}
            </tds-body-cell>
            <tds-body-cell
                cell-key="status"
                disable-padding="false"
                text-align="right">
                    <tds-icon style="color: var(--tds-positive)" *ngIf="batchJob.status" name="tick" size="32px" svg-title="Batch job succeeded"></tds-icon>
                    <tds-icon style="color: var(--tds-negative);" *ngIf="!batchJob.status" name="cross" size="32px" svg-title="Batch job failed"></tds-icon>
            </tds-body-cell>
        </tds-table-body-row>
    </tds-table-body>
</tds-table>